<template>
  <div>
    <search-bar
      isMinimal
      :state="state"
      :indexes="indexes"
      :isIndexesLoaded="true"
      :isScopedSearch="true"
      @keywordChanged="handleKeywordChange"
    />
    <search-suggestion-button
      :scope="state.key"
      @clicked="handleKeywordChange"
    />
  </div>
</template>

<script>
import SearchBar from '@/components/search/Bar'
import SearchSuggestionButton from '@/components/search/SearchSuggestionButton'

export default {
  name: 'searchBarDashboard',
  components: {
    SearchBar,
    SearchSuggestionButton
  },
  props: {
    state: {
      type: Object,
      required: true
    },
    indexes: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleKeywordChange (query) {
      const key = this.$route.name.split('.')[0]

      this.$router.push({
        name: `${key}.explore`,
        query: {
          keyword: query
        },
        params: {
          category: this.state.index
        }
      })
    }
  }
}
</script>
